import { Select } from 'antd'
import React, { useState } from 'react'
import { useTranslation } from 'next-i18next'
import { FilterMessageOption } from 'src/core/models'
import styles from './MessageListSelector.module.scss'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { filterMessageByOption, userAuthenticatedState } from 'src/features'
const { Option } = Select

const filterOptions = {
  ALL: 'ALL',
  INBOX: 'INBOX',
  SENT: 'SENT',
  NON_READ: 'NON_READ'
}

const MessageListSelector: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const user = useAppSelector(userAuthenticatedState)
  const [selectedFilter, setSelectedFilter] = useState(filterOptions.ALL)

  const handleChange = (value: FilterMessageOption) => {
    setSelectedFilter(value)
    dispatch(filterMessageByOption({ option: value, userId: user?.id }))
  }

  return (
    <Select
      value={selectedFilter}
      onChange={handleChange}
      className={styles.selectMessages}
    >
      <Option value={filterOptions.ALL}>{t('Messages.All')}</Option>
      <Option value={filterOptions.INBOX}>{t('Messages.Inbox')}</Option>
      <Option value={filterOptions.SENT}>{t('Messages.Sent')}</Option>
      <Option value={filterOptions.NON_READ}>{t('general.Unread')}</Option>
    </ Select>
  )
}

export default MessageListSelector
